import { PartitionLoopCompareJCountHIState } from "./PartitionLoopCompareJCountHIState";
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { IQuickSortState } from "../../IQuickSortState";
import { QuickSortStep } from '../../enums/QuickSortStep';
import { IQuickSortContext } from '../../IQuickSortContext';

export class PartitionAssignJCountState implements IQuickSortState {
  
  ThisQuickSortStep = QuickSortStep.PartitionAssignJCount;

  Description = "Assign j value";

  private _savedState : { JCount : number | undefined } | undefined;

  private _context : IQuickSortContext | undefined;

  SetContext(context: IQuickSortContext): void {
    this._context = context;
  }  
  
  Do(): void {
    if (this._savedState === undefined) {
      this._savedState = {
        JCount: this._context?.JCount
      }
    }
    else {
      this._savedState.JCount = this._context?.JCount;
    }
    
    if (this._context && this._context.Lo !== undefined) {
      this._context.JCount = this._context.Lo;
    }
  }

  Undo(): void {
    if (this._savedState && this._context) {
      this._context.JCount = this._savedState.JCount;
    }
  }

  Exit(): void {
    if (this._context !== undefined) {
      this._context.TransitionTo(new PartitionLoopCompareJCountHIState());
    }
  }
}